import { render, staticRenderFns } from "./PropostaAvalista.vue?vue&type=template&id=4d9458cb"
import script from "./PropostaAvalista.vue?vue&type=script&lang=js"
export * from "./PropostaAvalista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports